import {BreadcrumbType} from 'platform/components';

import {useGetBranchListQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {AddUserForm} from './components/AddUserForm';

export type AddUserPageProps = {
  name?: string; // TODO with BE data and extract to new file
};

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.settings.labels.userManagement'),
    href: settingsRoutes.userManagement,
  },
];

export function AddUser() {
  const {data, isLoading} = useGetBranchListQuery();

  return (
    <SettingsTemplate
      isLoading={!data || isLoading}
      header={{breadcrumbs}}
      data-testid="settings-management-settings-layout"
    >
      <AddUserForm />
    </SettingsTemplate>
  );
}
